import { Alert, MenuItem } from "@mui/material";
import { type AlmanacGroup } from "portal/components/categoryTemplates/useAlmanacOptions";
import { AlmanacSelectorField } from "./AlmanacSelectorField";
import { Field } from "formik";
import {
  MOST_SIMILAR_TO_OPTIONS,
  translateCategoryName,
} from "portal/utils/categoryCollection/category";
import { Select } from "formik-mui";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

interface AlmanacMostSimilarFieldsProps {
  almanacGroups: AlmanacGroup[];
  defaultAlmanacId: string;
}

export const AlmanacMostSimilarFields: FC<AlmanacMostSimilarFieldsProps> = ({
  almanacGroups,
  defaultAlmanacId,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {defaultAlmanacId ? (
        <AlmanacSelectorField
          almanacGroups={almanacGroups}
          name="sourceAlmanacId"
        />
      ) : (
        <Alert severity="warning">
          {t("components.categoryTemplates.errors.noAlmanacsAvailable")}
        </Alert>
      )}
      <Field
        component={Select}
        name="mostSimilarTo"
        label={t("components.categoryTemplates.fields.mostSimilarTo")}
        formControl={{ fullWidth: true }}
        formHelperText={{
          children: t(
            "components.categoryTemplates.fields.mostSimilarToHelper"
          ),
        }}
      >
        {MOST_SIMILAR_TO_OPTIONS.map((categoryName) => (
          <MenuItem key={categoryName} value={categoryName}>
            {categoryName === "Crop"
              ? t("components.categoryTemplates.fields.mostSimilarToCrop")
              : translateCategoryName(t, categoryName)}
          </MenuItem>
        ))}
      </Field>
    </>
  );
};
